'use strict';

var angularModule = angular.module('t2g.common.data-access.accounting', []);

module.exports = angularModule;

angularModule.factory('AccountingResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/accounting/:subResource0/:subResource1';

  var resource = $resource(
    resourceUrl,
    {},
    {
      createInvoice: { method: 'POST', isArray: false, params: { subResource0: 'invoice' } },
      updateInvoice: { method: 'PUT', isArray: false, params: { subResource0: 'invoice' } },
      getForCustomer: { method: 'GET', isArray: false, params: { subResource0: 'customer' } },
      removeInvoice: { method: 'DELETE', isArray: false, params: { subResource0: 'invoice' } },
    },
  );

  return resource;
});

angularModule.factory('AccountingDA', function(AccountingResource) {
  return {
    createInvoice: createInvoice,
    updateInvoice: updateInvoice,
    removeInvoice: removeInvoice,
    getForCustomer: getForCustomer,
  };

  function removeInvoice(invoiceId) {
    return AccountingResource.removeInvoice({ subResource1: invoiceId }).$promise;
  }

  function getForCustomer(customerId) {
    return AccountingResource.getForCustomer({ subResource1: customerId }).$promise.then(function(
      response,
    ) {
      return response.invoices;
    });
  }

  function createInvoice(invoice) {
    return AccountingResource.createInvoice(invoice).$promise;
  }

  function updateInvoice(invoiceId, invoice) {
    return AccountingResource.updateInvoice({ subResource1: invoiceId }, invoice).$promise;
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/accounting.js